import { PropsWithChildren, useEffect } from 'react';
import * as amplitude from '@amplitude/analytics-browser';

export default function AmplitudeProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY as string, {
      defaultTracking: {
        pageViews: false,
        sessions: false,
        formInteractions: false,
        fileDownloads: false
      },
      trackingOptions: {
        ipAddress: false // 개인정보 최소화
      },
      transport: 'beacon'
    });
  });

  return <>{children}</>;
}
